import { DocumentEntity, DocumentItemTypeEnum } from '@domain';

/**
 * Nº da imagem no documento inteiro — a MESMA varredura do preview da API
 * (document-preview.service) e do PDF: seções na ordem, itens na ordem;
 * IMAGE conta 1, GROUP_IMAGE conta 1 por foto.
 *
 * Para GROUP_IMAGE devolve o número da PRIMEIRA foto do grupo (a foto `i`
 * do grupo é `resultado + i`). Item não encontrado (lixeira, favoritos,
 * documento ainda não carregado) devolve `null` — o chamador esconde o número.
 */
export function imageNumberForItem(
    document: DocumentEntity | null | undefined,
    itemId: string | undefined
): number | null {
    if (!document?.sessions || !itemId) return null;

    let imageNumber = 0;
    for (const session of document.sessions) {
        for (const item of session.items ?? []) {
            if (item.type === DocumentItemTypeEnum.IMAGE) {
                imageNumber++;
                if (item._id === itemId) return imageNumber;
            } else if (item.type === DocumentItemTypeEnum.GROUP_IMAGE) {
                const first = imageNumber + 1;
                imageNumber += Array.isArray(item.value) ? item.value.length : 0;
                if (item._id === itemId) return first;
            }
        }
    }

    return null;
}
